import IconHerald from './IconHerald';

export default IconHerald;